import React from 'react';
import { useNavigate } from 'react-router-dom';
import QuizClock from './QuizClock';
import './QuizPageHeader.css';

const QuizPageHeader = ({ 
  subjectName, 
  displayTitle, 
  seconds, 
  onQuit 
}) => {
  const navigate = useNavigate();

  const handleQuit = () => {
    if (onQuit) {
      onQuit();
    } else {
      navigate('/student/home');
    }
  };

  return (
    <header className="quiz-sticky-header">
      <div className="header-grid">
        <div className="header-left">
          <button
            onClick={handleQuit}
            className="btn accent-btns"
            aria-label="Quit Quiz"
          >
            <span className="quit-arrow">←</span> 
            <span className="quit-text">Quit Quiz</span>
          </button>
        </div>

        <div className="header-center">
          {subjectName && <span className="quiz-subject-subtitle">{subjectName}</span>}
          <h1 className="quiz-page-title">{displayTitle}</h1>
        </div>

        <div className="header-right">
          <QuizClock seconds={seconds} />
        </div>
      </div>
    </header>
  );
};

export default QuizPageHeader;